import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import SidebarAdmin from "./sidebar-admin"; 
import AdminHeader from "./AdminHeader";  

const AdminLayout: React.FC = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  const handleLogout = () => {
    // Votre logique de déconnexion
    console.log("Logout triggered");
  };

  return (
    <div className={`dashboard-layout ${isSidebarCollapsed ? "sidebar-collapsed" : ""}`}>
      {/* Sidebar fixe à gauche */}
      <aside className="dashboard-sidebar">
        <SidebarAdmin collapsed={isSidebarCollapsed} />
      </aside>

      {/* Contenu principal */}
      <div className="dashboard-main">
        <AdminHeader toggleSidebar={toggleSidebar} onLogout={handleLogout} />

        {/* Le composant Outlet injectera la page active ici */}
        <main className="dashboard-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;